import KitFadeView from '@omni/kit/components/KitFadeView';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { ViewStyle } from 'react-native';

import PlayerButton, { PlayerButtonSizes } from './PlayerButton';

export interface PlayPauseControlProps {
  isVisible?: boolean;
  isPlaying: boolean;
  size?: PlayerButtonSizes;
  onPress?: () => void;
  onPressOut?: () => void;
  onBlur?: () => void;
  style?: ViewStyle;
}

export default function PlayPauseControl({
  isVisible,
  isPlaying,
  size,
  onPress,
  onPressOut,
  style,
}: PlayPauseControlProps): ReactElement {
  const { t } = useTranslation('common');

  return (
    <KitFadeView show={isVisible} keepElementSize>
      <PlayerButton
        size={size}
        icon={isPlaying ? 'pause' : 'play'}
        onPress={onPress}
        onPressOut={onPressOut}
        style={style}
        tooltipProps={{
          label: isPlaying ? `${t('pause')} (k)` : `${t('play')} (k)`,
        }}
      />
    </KitFadeView>
  );
}
